import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgAlert = (props) => {
    const { color } = props;
    return (React.createElement("path", { fill: color, fillRule: "evenodd", d: "M10.363 3.064C10.71 2.404 11.331 2 12 2c.67 0 1.29.403 1.637 1.064l8.106 15.622c.34.68.343 1.517.006 2.199-.337.682-.962 1.106-1.642 1.115H3.893c-.68-.009-1.305-.433-1.642-1.115a2.508 2.508 0 0 1 .006-2.2l8.106-15.621zm9.605 16.543L12 4.252 4.045 19.58a.512.512 0 0 0 0 .42h15.91c.06-.122.06-.3.013-.393zM12 18a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1z" }));
};
export default factorySvgIcon(SvgAlert);
//# sourceMappingURL=SvgAlert.js.map